<lib-survey-layout>
  <lib-survey
    (surveyLoad)="onSurveyLoad()"
    (pageChanged)="onPageChange()"
    (submitted)="onSubmit()"
  >
  </lib-survey>
</lib-survey-layout>
